// -------------------------------------------------------
// Paths
// -------------------------------------------------------

const PATH_ASSETS =
  process.env.NODE_ENV !== 'production' ? '' : '/cms/rekonstrukce-okupace/';

export const PATH = {
  FRAME: 'https://player.ceskatelevize.cz/',
  IMG: process.env.NODE_ENV !== 'production' ? '/img/' : `${PATH_ASSETS}img/`,
  SND: process.env.NODE_ENV !== 'production' ? '/snd/' : `${PATH_ASSETS}snd/`,
  PHOTO:
    process.env.NODE_ENV !== 'production'
      ? '/content/photo/'
      : `${PATH_ASSETS}content/photo/`,
  SCREENS:
    process.env.NODE_ENV !== 'production'
      ? '/content/screens/'
      : `${PATH_ASSETS}content/screens/`,
  MESSAGES:
    process.env.NODE_ENV !== 'production'
      ? '/local-data/messages/'
      : `/cms/rekonstrukce-okupace-messages/data/`,
};

// -------------------------------------------------------
// Routing
// -------------------------------------------------------

export const ROUTE = {
  CATEGORY: '/kategorie',
  DETAIL: '/detail',
  ABOUT: '/o-projektu',
};

// -------------------------------------------------------
// Content Type
// -------------------------------------------------------

export const CONTENT_TYPE = {
  VIDEO: 'v',
  PHOTO: 'i',
};

// -------------------------------------------------------
// VIDEO
// -------------------------------------------------------

export const INTRO_VIDEO = '32456';
export const SEEK_VALUE = 2000;
export const VIDEO_EVENT = {
  STARTED: 'started',
  PLAYING: 'plaing',
};



// WEBPACK FOOTER //
// ./src/constants.js